import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer', '/issuers')
const reducer = generator.generate()

export default reducer
